<template>
    <mainWire-add-form></mainWire-add-form>
</template>


<script>

    import MainWireAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            MainWireAddForm,
        },

    }
</script>

